import { Buffer } from 'buffer';

export const setStorage = (key, data) => {
    try {
        data = Buffer.from(Buffer.from(encodeURI(data).toString('base64')).toString('base64'));
    } catch (e) {
        console.error(`Error encoding data for localStorage with key "${key}":`, e);
    }
    window.localStorage.setItem(key, data);
};

export const getStorage = (key, defaultValue = null) => {
    let data = window.localStorage.getItem(key) || defaultValue;

    if (data) {
        try {
            data = decodeURI(Buffer.from(Buffer.from(data, 'base64'), 'base64'));
            data = JSON.parse(data);
        } catch (e) {
            console.error(`Error parsing data from localStorage for key "${key}":`, e);
        }
    }

    return data;
};

export const removeStorage = (key, shouldGetData = false) => {
    let data = null;

    if (shouldGetData) {
        data = getStorage(key);
    }

    window.localStorage.removeItem(key);
    return data;
};

export const setCookie = (cname, cvalue, exdays) => {
    const d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    const expires = 'expires=' + d.toUTCString();
    document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
};

export const getCookie = (cname) => {
    const name = cname + '=';
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return '';
};

export const readAllChunks = (readableStream, setPercentage, chunksSeparator = '\n') => {
    const reader = readableStream.getReader();
    // One decoder in streaming mode: a multi-byte character split across
    // network chunks must not decode to replacement characters.
    const decoder = new TextDecoder();
    let buffer = ''; // keeps data between chunks
    const chunks = [];

    function pump() {
        return reader.read().then(({ value, done }) => {
            if (done) {
                buffer += decoder.decode();
                if (buffer.trim()) {
                    chunks.push(buffer);
                }
                return chunks;
            }

            buffer += decoder.decode(value, { stream: true });

            const parts = buffer.split(chunksSeparator);
            buffer = parts.pop(); // last part is incomplete yet

            for (const part of parts) {
                if (!part.trim()) {
                    continue;
                }
                if (/^\d+$/.test(part.trim())) {
                    setPercentage(parseInt(part.trim(), 10));
                } else {
                    chunks.push(part);
                }
            }

            return pump();
        });
    }

    return pump();
};

export const isChecked = (value) => {
    return !!value;
};

export const appendQueryParamsToUrl = (url, params) => {
    let shouldAppendAmpersand = false;
    Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '' && value !== 'null' && value !== 'undefined') {
            url += !shouldAppendAmpersand ? `?${key}=${value}` : `&${key}=${value}`;
            shouldAppendAmpersand = true;
        }
    });

    return url;
};

export const isStringValidJSON = (str) => {
    try {
        JSON.parse(str);
        return true;
    } catch (e) {
        return false;
    }
};

export const copyToClipboard = async (text) => {
    try {
        await navigator.clipboard.writeText(text);
    } catch {
        const el = document.createElement('textarea');
        el.value = text;
        el.style.position = 'absolute';
        el.style.left = '-9999px';
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
    }
};

export const compareWorkingUnits = (a, b) => {
    if (!a || !b) return 0;
    if (a?.id === -1) return -1;
    if (b?.id === -1) return 1;

    const worktypeComparison = (a.worktype?.worktype || '').localeCompare(b.worktype?.worktype || '');
    if (worktypeComparison !== 0) return worktypeComparison;

    const channelComparison = (a.channel?.name || '').localeCompare(b.channel?.name || '');
    if (channelComparison !== 0) return channelComparison;

    return (a.task?.name || '').localeCompare(b.task?.name || '');
};

export const compareLocations = (a, b) => {
    if (!a || !b) return 0;
    if (a?.id === -1) return -1;
    if (b?.id === -1) return 1;
    return [a?.code, a?.city].join('-').localeCompare([b?.code, b?.city].join('-'));
};

export const simpleHash = (str) => {
    let hash = 0;
    if (str.length === 0) {
        return hash;
    }
    for (let i = 0; i < str.length; i++) {
        const char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char; // A common bitwise operation for mixing
        hash |= 0; // Convert to 32bit integer
    }
    return hash;
};
